<app-dashboard-layout [notDashboard]="true" [downloader]="downloader" [loading]="loading || skeletonLoader">
  <app-notification-alert [data]="notification"></app-notification-alert>

  <section class="bg-white border rounded-md p-6">
    <header class="border-b text-lg w-full pb-2 md:text-xl">
      Accommodation Reservation
    </header>

    <section *ngIf="skeletonLoader">
      <div class="border rounded-md bg-gray-300 h-16 my-8 animate-pulse"></div>
      <div class="border rounded-md mx-auto max-w-md bg-gray-300 h-8 my-8 animate-pulse"></div>
    </section>

    <div *ngIf="!skeletonLoader" class="pt-4 space-y-6">

      <!-- Unpaid: reservation details -->
      <div *ngIf="!accommodation?.ReservationFullyPaid" class="space-y-4">
        <div class="bg-blue-50 border border-blue-200 rounded-md p-4 space-y-1">
          <p class="text-sm text-gray-600">You have been assigned <strong>{{ accommodationreservation.Spaces }}</strong> space(s) in:</p>
          <p class="text-base font-semibold text-gray-800">
            {{ accommodationreservation.HallName | titlecase }} &mdash; Room {{ accommodationreservation.Room }}
          </p>
        </div>

        <div class="bg-yellow-50 border border-yellow-200 rounded-md p-4 text-sm text-gray-700 space-y-2">
          <p>
            This reservation will be held for <strong>{{ accommodationreservation.ExpiryDays }}</strong> day(s)<span *ngIf="!accommodationreservation.IncludeWeekendsInReservationExpiryPeriod"> (excluding weekends)</span>,
            until <strong>{{ accommodationreservation.ExpiryDateTime | date: "EEEE, MMMM d, y, h:mm a" }}</strong>.
          </p>
          <p>
            If payment is not received before then, this reservation will automatically expire and the space(s) may be reassigned.
          </p>
        </div>

        <div class="flex flex-col sm:flex-row gap-3">
          <a routerLink="/payments/advice" class="w-full sm:w-auto">
            <app-button-primary [outline]="true" class="w-full">
              View Payment Advice
            </app-button-primary>
          </a>
          <a routerLink="/payments/tranzgate" class="w-full sm:w-auto">
            <app-button-primary class="w-full">
              Make Payment
            </app-button-primary>
          </a>
          <app-button-primary
            (click)="downloadApplicationForm()"
            [disabled]="loading"
            class="w-full sm:w-auto"
          >
            Download Application Form
          </app-button-primary>
          <app-button-primary
            (click)="accommodationPaymentConfirmation()"
            [disabled]="loading"
            class="w-full sm:w-auto"
          >
            Download Confirmation
          </app-button-primary>
        </div>
      </div>

      <!-- Paid: confirmation download -->
      <div *ngIf="accommodation?.ReservationFullyPaid" class="space-y-4">
        <div class="bg-green-50 border border-green-200 rounded-md p-4 text-sm text-gray-700 space-y-1">
          <p class="font-semibold text-green-800">Payment Confirmed</p>
          <p>Your accommodation reservation has been fully paid. Download your confirmation below.</p>
        </div>
        <div class="flex flex-col sm:flex-row gap-3">
          <app-button-primary
            (click)="downloadApplicationForm()"
            [disabled]="loading"
            class="w-full sm:w-auto"
          >
            Download Application Form
          </app-button-primary>
          <app-button-primary
            (click)="accommodationPaymentConfirmation()"
            [disabled]="loading"
            class="w-full sm:w-auto"
          >
            Download Confirmation
          </app-button-primary>
        </div>
      </div>

      <!-- Hall instructions -->
      <div
        *ngIf="accommodationreservation?.HallInstructions || accommodationreservation?.ProgrammeTypeAccomodationInstructions"
        class="border-t pt-4 space-y-3"
      >
        <p class="text-sm font-semibold text-gray-700">Terms &amp; Conditions / Further Instructions</p>
        <div [innerHtml]="accommodationreservation.HallInstructions" class="text-sm text-gray-600"></div>
        <div [innerHtml]="accommodationreservation.ProgrammeTypeAccomodationInstructions" class="text-sm text-gray-600"></div>
      </div>

    </div>
  </section>
</app-dashboard-layout>
